import React from 'react';
import { NextPage } from 'next';
import dynamic from 'next/dynamic';

import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import Layout from '~/src/features/_layout';
import { initialProps } from '~/src/helpers/basePageFunc';
import { TState } from '~/src/store';
import { getCurrentCity, selectCompanyName } from '~/src/store/selectors/city';

const PaymentsLayout = dynamic(() => import('~/src/features/payments-abn'));

interface IProps {
    currentCity: ICurrentCity,
    companyName: string,
}

const NewPaymentsPage: NextPage<IProps> = ({ currentCity, companyName }) => {
    return (
        <Layout
            title={`Оплата услуг ${companyName} банковской картой онлайн | Заплатить за интернет, ТВ, телефон в ${currentCity.cityIn}`}
            description={`Оплата услуг провайдера ${companyName} в ${currentCity.cityIn} без комиссии. Выберите любой удобный способ онлайн оплаты интернета, телевидения и телефонии или подключите услугу "Автоплатеж". Подробнее на сайте`}
            withMenu={true}
            withChat={true}
            withFooter={true}
            bgColor={COLORS.BgMain}
        >
            <PaymentsLayout/>
        </Layout>
    );
};

NewPaymentsPage.getInitialProps = async(options) => {
    await initialProps(options, { isNeedAuthData: true });
    const state: TState = options.store.getState();
    const currentCity = getCurrentCity(state);
    const companyName = selectCompanyName(state);

    return { currentCity, companyName };
};

export default NewPaymentsPage;
